import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'department_extended_list_item';
export const useDepartmentExtendedListItemTranslation = ():
UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation(namespace, { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    info_permission_tags: 'Подразделение предоставляет доступ к тегам доступа:',
    info_lists: 'Подразделение предоставляет доступ к спискам:',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    info_permission_tags: 'The division provides access to access tags:',
    info_lists: 'The division provides access to lists:',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    info_permission_tags: 'La división proporciona acceso a etiquetas de acceso:',
    info_lists: 'La división proporciona acceso a las siguientes listas:',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    info_permission_tags: 'A divisão fornece acesso às etiquetas de acesso:',
    info_lists: 'A divisão fornece acesso às listas:',
  },
}) : {}) as Record<string, unknown>;
